import { render, staticRenderFns } from "./EditorialLists.vue?vue&type=template&id=426cd964&"
import script from "./EditorialLists.vue?vue&type=script&lang=js&"
export * from "./EditorialLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports